import { defineComponent as p, openBlock as o, createElementBlock as e, mergeProps as u, unref as l, renderSlot as g, createElementVNode as n, createCommentVNode as m } from "vue";
import { useScalarIcon as C } from "../hooks/useScalarIcon.js";
const c = { key: 0 }, f = { key: 1 }, h = { key: 2 }, k = { key: 3 }, Z = { key: 4 }, w = { key: 5 }, y = {
  name: "ScalarIconCircleNotch"
}, A = /* @__PURE__ */ p({
  ...y,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: a } = C(s);
    return (i, t) => (o(), e("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, l(d)), [
      g(i.$slots, "default"),
      l(a) === "bold" ? (o(), e("g", c, t[0] || (t[0] = [
        n("path", { d: "M236,128a108,108,0,0,1-216,0c0-42.52,24.73-81.34,63-98.9A12,12,0,1,1,93,50.91C63.24,64.57,44,94.83,44,128a84,84,0,0,0,168,0c0-33.17-19.24-63.43-49-77.09A12,12,0,1,1,173,29.1C211.27,46.66,236,85.48,236,128Z" }, null, -1)
      ]))) : l(a) === "duotone" ? (o(), e("g", f, t[1] || (t[1] = [
        n("path", {
          d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M232,128a104,104,0,0,1-208,0c0-41,23.81-78.36,60.66-95.27a8,8,0,0,1,6.68,14.54C60.15,61.59,40,93.27,40,128a88,88,0,0,0,176,0c0-34.73-20.15-66.41-51.34-80.73a8,8,0,0,1,6.68-14.54C208.19,49.64,232,87,232,128Z" }, null, -1)
      ]))) : l(a) === "fill" ? (o(), e("g", h, t[2] || (t[2] = [
        n("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,176A72,72,0,0,1,92,65.64a8,8,0,0,1,8,13.85,56,56,0,1,0,56,0,8,8,0,0,1,8-13.85A72,72,0,0,1,128,200Z" }, null, -1)
      ]))) : l(a) === "light" ? (o(), e("g", k, t[3] || (t[3] = [
        n("path", { d: "M230,128a102,102,0,0,1-204,0c0-40.18,23.35-76.86,59.5-93.45a6,6,0,0,1,5,10.9C58.61,60.09,38,92.49,38,128a90,90,0,0,0,180,0c0-35.51-20.61-67.91-52.5-82.55a6,6,0,0,1,5-10.9C206.65,51.14,230,87.82,230,128Z" }, null, -1)
      ]))) : l(a) === "regular" ? (o(), e("g", Z, t[4] || (t[4] = [
        n("path", { d: "M232,128a104,104,0,0,1-208,0c0-41,23.81-78.36,60.66-95.27a8,8,0,0,1,6.68,14.54C60.15,61.59,40,93.27,40,128a88,88,0,0,0,176,0c0-34.73-20.15-66.41-51.34-80.73a8,8,0,0,1,6.68-14.54C208.19,49.64,232,87,232,128Z" }, null, -1)
      ]))) : l(a) === "thin" ? (o(), e("g", w, t[5] || (t[5] = [
        n("path", { d: "M228,128a100,100,0,0,1-200,0c0-39.4,22.9-75.37,58.33-91.63a4,4,0,1,1,3.34,7.27C57.07,58.6,36,91.71,36,128a92,92,0,0,0,184,0c0-36.29-21.07-69.4-53.67-84.36a4,4,0,1,1,3.34-7.27C205.1,52.63,228,88.6,228,128Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  A as default
};
